<template>
    <v-navigation-drawer app v-model="drawer">
        <v-list-item>
            <v-list-item-content>
                <v-list-item-title class="title" style="height: 40px; display: flex; align-items: center;">
                    Dashboard
                </v-list-item-title>
            </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list>
            <template v-for="item in menuItems">
                <v-list-item v-if="item.items === undefined" link :to="item.route" color="teal">
                    <v-list-item-icon>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item>
                <v-list-group v-else :prepend-icon="item.icon" no-action color="teal">
                    <template v-slot:activator>
                        <v-list-item-content>
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item-content>
                    </template>

                    <v-list-item v-for="(child, idx) in item.items" :key="idx" link color="teal"
                        :prepend-icon="child.icon" :to="child.route">
                        <v-list-item-title>{{ child.title }}</v-list-item-title>

                        <v-list-item-icon>
                            <v-icon>{{ child.icon }}</v-icon>
                        </v-list-item-icon>
                    </v-list-item>
                </v-list-group>
            </template>
        </v-list>
        <template v-slot:append>
            <div class="px-16 pb-4">
                <v-btn block outlined color="teal" @click="logout">
                    <v-icon>
                        power_settings_new
                    </v-icon>
                    <span>&nbsp;{{ $t('logout') }}</span>
                </v-btn>
            </div>
        </template>
    </v-navigation-drawer>
</template>

<script>
import { MixinAuth } from "../../mixins"

export default {
    name: "Nav",
    mixins: [MixinAuth],
    computed: {
        menuItems() {
            return this.$store.getters.mainMenu;
        },
        drawer: {
            get() {
                return this.$store.getters.drawer
            },
            set(val) {
                this.$store.commit('setDrawer', val)
            },
        },
    }
}
</script>

<style scoped>
.v-list-item:hover {
    text-decoration: none;
}

.v-list-item__content {
    height: 56px;
}
</style>
